import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';

import {
	TYPE_MISSING,
	TYPE_PAGE,
	TYPE_REDIRECT,
	TYPE_SERVER_ERROR,
	TYPE_UNREACHABLE,
} from '~/model/pages';



const messages = defineMessages({
	[TYPE_MISSING]: {
		id: 'ui.contentOverview.pageTypes.missing',
	},
	[TYPE_PAGE]: {
		id: 'ui.contentOverview.pageTypes.page',
	},
	[TYPE_REDIRECT]: {
		id: 'ui.contentOverview.pageTypes.redirect',
	},
	[TYPE_SERVER_ERROR]: {
		id: 'ui.contentOverview.pageTypes.error',
	},
	[TYPE_UNREACHABLE]: {
		id: 'ui.contentOverview.pageTypes.unreachable',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
	height?: number;
	percentageFactor?: number;
};

const PageTypeChart = (props: Props) => {
	const {
		data,
		height,
		percentageFactor,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: TYPE_PAGE,
			label: intl.formatMessage(messages[TYPE_PAGE]),
			color: '#42CC67',
		},
		{
			value: TYPE_REDIRECT,
			label: intl.formatMessage(messages[TYPE_REDIRECT]),
			color: '#367be2',
		},
		{
			value: TYPE_MISSING,
			label: intl.formatMessage(messages[TYPE_MISSING]),
			color: '#FE8719',
		},
		{
			value: TYPE_SERVER_ERROR,
			label: intl.formatMessage(messages[TYPE_SERVER_ERROR]),
			color: '#FF5959',
		},
		{
			value: TYPE_UNREACHABLE,
			label: intl.formatMessage(messages[TYPE_UNREACHABLE]),
			color: '#8595A6',
		},
	];

	return (
		<DonutPagesChart
			categories={categories}
			data={data}
			height={height}
			name="type"
			percentageFactor={percentageFactor}
		/>
	);
};



export default React.memo(PageTypeChart);
